import * as React from 'react';
import styled from 'styled-components';
import IAdditionStyle from '../../models/IAdditionStyle';
import onlineTheme from '../../themes/online';
import sunbitLoader from '../../assets/sunbitLoader.gif';

export type LoaderProps = {
  active: boolean;
  component?: boolean;
  loaderImage?: string;
  styleLoaderWrapper?: IAdditionStyle;
  className?: string;
  dataAt?: string;
};

// tslint:disable-next-line:variable-name
const SLoaderWrap = styled.div<{ component?: boolean; styleLoaderWrapper: IAdditionStyle }>(
  ({ component, styleLoaderWrapper }) => ({
    position: component ? 'absolute' : 'fixed',
    zIndex: 99999,
    top: 0,
    left: 0,
    width: component ? '100%' : '100vw',
    height: component ? '100%' : '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    userSelect: 'none',
    ...styleLoaderWrapper,
  })
);

// tslint:disable-next-line:variable-name
const SLoaderImage = styled.img({
  width: '30%',
  maxWidth: 150,
});

// tslint:disable-next-line:variable-name
const Loader: React.FC<LoaderProps> = (props) => {
  Loader.defaultProps = {
    loaderImage: onlineTheme.icons.loaderSunbit,
  };

  if (!props.active) {
    return null;
  }
  return (
    <SLoaderWrap
      data-at={props.dataAt}
      className={props.className}
      component={props.component}
      styleLoaderWrapper={props.styleLoaderWrapper}
    >
      <SLoaderImage src={sunbitLoader} />
    </SLoaderWrap>
  );
};

export default Loader;
